import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

import {
  RunnerList,
  RunnerDelete,
  RunnerStatusChange,
} from "../../services/runner.services";

const RunnerListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [globalSearch, setGlobalSearch] = useState("");
  const [statusUpdate, setStatusUpdate] = useState(false);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Temple"), url: "/admin/temples/list/1" },
    { title: t("Runner"), url: "" },
  ];

  const fetchData = () => {
    setLoader(true);

    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    formData.append("global_search", globalSearch);

    RunnerList(formData)
      .then((res) => {
        setList(res?.data?.list || []);
        setTotalRecords(res?.data?.total_records || 0);
        setPage(res?.data?.page || 1);
        setLoader(false);
        console.log(res?.data?.list);
      })
      .catch(() => setLoader(false));
  };

  useEffect(() => {
    fetchData();
  }, [page, globalSearch, statusUpdate]);

  const resetFilter = () => {
    setGlobalSearch("");
    setPage(1);
  };

  // 🔹 Delete Runner
  const handleDelete = (id) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        RunnerDelete(id).then((res) => {
          setStatusUpdate((prev) => !prev);
          Swal.fire({
            icon: res.success ? "success" : "error",
            text: res.message,
            ...SWAL_SETTINGS,
          });
        });
      }
    });
  };

  const handleStatusChange = (id) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("You are about to change the status of this runner"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("Confirm"),
      cancelButtonText: t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        RunnerStatusChange({ o_id: id }).then((res) => {
          setStatusUpdate((prev) => !prev);
          Swal.fire({
            icon: res.success ? "success" : "error",
            text: res.message,
            ...SWAL_SETTINGS,
          });
        });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />

      <div className="card custom-card">
        <div className="card-body">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="main-content-label">{t("Runner")}</h6>

            <div className="d-flex align-items-center">
              <div className="form-group mb-0 me-3">
                <div className="form-group mb-0 rangepicker_container filter_design">
                  <i className="fa fa-search calender_icon"></i>
                  <input
                    type="search"
                    className="form-control"
                    value={globalSearch}
                    placeholder={t("input_placeholder_search")}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                </div>
              </div>

              <button
                type="button"
                className="btn btn-warning me-2"
                onClick={resetFilter}
              >
                {t("btn_reset_filter")}
              </button>

              <button
                className="btn ripple btn-main-primary signbtn"
                onClick={() => navigate("/admin/temple-runner/add")}
              >
                {t("btn_add_new")}
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-bordered w-100">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("Name")}</th>
                  <th>{t("Email")}</th>
                  <th>{t("Phone Number")}</th>
                  <th>{t("Location")}</th>
                  <th>{t("Status")}</th>
                  <th>{t("Action")}</th>
                </tr>
              </thead>

              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan={7}>
                      <Loader />
                    </td>
                  </tr>
                ) : list.length > 0 ? (
                  list.map((runner, index) => (
                    <tr key={runner._id}>
                      <td>
                        {(page - 1) * itemPerPage + index + 1}
                      </td>
                      <td>{runner.name}</td>
                      <td>{runner.email || "-"}</td>
                      <td>{runner.phone_number || "-"}</td>
                      <td>
                        {runner.city}, {runner.state}, {runner.country}
                      </td>
                      <td>
                        <button
                          className={`btn ripple ${
                            runner.status
                              ? "btn-main-primary signbtn"
                              : "btn-secondary"
                          }`}
                          onClick={() => handleStatusChange(runner._id)}
                        >
                          {runner.status ? t("Active") : t("Inactive")}
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn ripple btn-main-primary signbtn me-2"
                          onClick={() =>
                            navigate(`/admin/temple-runner/view/${runner._id}`)
                          }
                        >
                          {t("View")}
                        </button>

                        <button
                          className="btn btn-success me-2"
                          onClick={() =>
                            navigate(`/admin/temple-runner/edit/${runner._id}`)
                          }
                        >
                          {t("Edit")}
                        </button>

                        <button
                          className="btn btn-danger"
                          onClick={() => handleDelete(runner._id)}
                        >
                          {t("Delete")}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      {t("msg_no_records")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-3">
            <b>
              {t("msg_total_records")} : {totalRecords}
            </b>
          </div>

          {totalRecords > 0 && (
            <CustomPagination
              datalength={totalRecords}
              itemperpage={itemPerPage}
              currentPage={page}
              setPage={setPage}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default RunnerListPage;
